
import axios from 'axios'
import { EXCLUIR_MANUTENCAO_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirManutencaoVeiculo (cod, veiculoId, empresaId) {
  const url = `${URL}/registro-manutencao-veiculo/${cod}/veiculo/${veiculoId}/empresa/${empresaId}/excluir`;

  return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_MANUTENCAO_VEICULO,
        payload: response
      })
  );
}
